import React from 'react';
import AppRoutes from './AppRoutes.jsx';
import '../src/Components/Scrollable/Scrollable.css';
import '../src/Components/App.css';

import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: process.env.NODE_ENV !== 'development'
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="app" style={{fontSize: '0.93em', width: "100%", height: "100%", zIndex:"0", position:"relative"}}>
        <AppRoutes />
      </div>
    </QueryClientProvider>
  );
}

export default App;
